import {remCalc} from '../_utils'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const overrides = {
    Button: {
        baseStyle: {
            fontWeight: 'medium',
        },
        variants: {
            'inverse-secondary': {
                border: remCalc(1),
                borderStyle: 'solid',
                borderColor: 'button.border.inverse-secondary-default',
                _hover: {
                    border: remCalc(2),
                    borderStyle: 'solid',
                    borderColor: 'button.border.inverse-secondary-default',
                },
                _focus: {
                    border: remCalc(2),
                    borderStyle: 'solid',
                    borderColor: 'button.border.inverse-secondary-default',
                },
                _active: {
                    border: remCalc(2),
                    borderStyle: 'solid',
                    borderColor: 'button.border.inverse-secondary-default',
                },
                _disabled: {
                    border: remCalc(2),
                    borderStyle: 'solid',
                    borderColor: 'button.border.inverse-secondary-default',
                    bg: 'button.background.inverse-secondary-disabled',
                },
            },
            'text-button': {
                fontWeight: 'normal',
                textStyle: 'body-small',
            },
            secondary: {
                border: remCalc(1),
                borderStyle: 'solid',
                borderColor: 'button.border.secondary-default',
                _active: {
                    border: remCalc(2),
                    borderStyle: 'solid',
                    borderColor: 'button.border.secondary-default',
                },
                _disabled: {
                    border: remCalc(2),
                    borderStyle: 'solid',
                    borderColor: 'button.border.secondary-default',
                },
                _hover: {
                    border: remCalc(2),
                    borderStyle: 'solid',
                    borderColor: 'button.border.secondary-default',
                    bg: 'background.primary-default',
                    color: 'button.border.secondary-default',
                },
                _pressed: {
                    border: remCalc(2),
                    borderStyle: 'solid',
                    color: 'button.text.inverse-secondary-default',
                    borderColor: 'button.border.secondary-default',
                },
            },
        },
    },
    PreFooter: {
        baseStyle: {
            benefitBarHeader: {
                textStyle: 'head-xxsmall',
                fontWeight: 'medium',
            },
            benefitBarText: {
                fontWeight: 'light',
            },
            newsletterContainer: {
                background: 'background.grey',
            },
            newsletterHeader: {
                color: 'text.inverse',
                fontWeight: 'normal',
            },
            newsletterText: {
                color: 'text.inverse',
            },
            newsletterButton: {
                variant: 'inverse-primary',
            },
        },
    },
    ProductDocumentation: {
        baseStyle: {
            tipIcon: {
                color: 'icons.background.secondary',
            },
            buttonPadding: {
                fontWeight: 500,
            },
        },
    },
    ProductView: {
        baseStyle: {
            inventoryLabelContainer: {
                pt: [remCalc(24), remCalc(24), remCalc(24), remCalc(24)],
            },
        },
    },
    ProductDetailBanner: {
        baseStyle: {
            codeText: {
                alignSelf: 'center',
            },
            tagText: {
                top: remCalc(0),
            },
        },
    },
    ProductRegistration: {
        baseStyle: {
            title: {
                textStyle: 'head-xlarge',
                fontWeight: 'normal',
            },
        },
    },
    ProductRegistrationStepper: {
        baseStyle: {
            stepNumber: {
                height: remCalc(22),
            },
            stepIndicator: {
                backgroundColor: 'icons.background.disable',
            },
        },
    },
    ProductRegistrationForm: {
        baseStyle: {
            fileNameContainer: {
                borderRadius: remCalc(8),
                borderColor: 'border.default',
            },
        },
    },
    ProductTile: {
        baseStyle: {
            favIcon: {
                top: remCalc(10),
                right: remCalc(10),
            },
            sku: {
                textStyle: 'body-xsmall',
                color: 'text.secondary',
                fontWeight: 'normal',
                font: 'secondary',
            },
            category: {
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
            },
            braunBundleBorderRadius: {
                borderRadius: {base: remCalc(16), lg: remCalc(16)},
            },
        },
    },
    DatePicker: {
        baseStyle: {
            customInput: {
                borderRadius: remCalc(8),
                borderColor: 'border.default',
                _hover: {
                    borderColor: 'border.default',
                },
                _focus: {
                    borderColor: 'border.default',
                },
                _focusVisible: {
                    borderColor: 'border.default',
                },
            },
        },
    },
    Footer: {
        baseStyle: {
            benefitText: {
                textStyle: 'head-xsmall',
                fontWeight: 'medium',
            },
            benefitIcons: {
                filter: 'brightness(0) invert(1)',
            },
            accordionItem: {
                borderColor: 'background.default',
            },
            accordionIcon: {
                color: 'background.default',
                boxSize: 'iconsSize.medium',
            },
            accordionList: {
                opacity: 1,
                paddingY: remCalc(8),
            },
            accordionHeading: {
                color: 'background.default',
            },
            paymentsLegal: {
                alignItems: 'center',
            },
            copyright: {
                mt: remCalc(0),
                whiteSpace: 'wrap',
                paddingRight: {base: remCalc(0), lg: remCalc(16)},
            },
            socialAppPrivacyContainer: {
                paddingRight: {base: remCalc(0), lg: remCalc(16)},
            },
            countryPayments: {
                flexShrink: '1',
            },
            teconsent: {
                textStyle: 'body-xsmall',
                border: 'none',
                opacity: '0.7',
                paddingLeft: remCalc(0),
            },
            socialsContainer: {
                boxSize: 'iconsSize.large',
                backgroundColor: 'background.default',
                borderRadius: '50%',
            },
            socials: {
                filter: 'brightness(0) saturate(100%)',
            },
            brandCountry: {
                gap: remCalc(0),
            },
            footerBrand: {
                pb: {base: remCalc(0), lg: remCalc(8)},
                width: remCalc(100),
                height: remCalc(42),
                color: 'text.inverse',
            },
            socialIcons: {
                gap: remCalc(24),
            },
        },
    },
    LinksList: {
        baseStyle: {
            heading: {
                color: 'text.inverse',
                opacity: 0.6,
            },
            headingLink: {
                opacity: 0.6,
            },
            list: {
                opacity: 0.8,
            },
        },
    },
    CountrySelectorFooter: {
        baseStyle: {
            textCode: {
                fontWeight: 'semibold',
            },
            footerText: {
                color: 'text.default',
            },
            headerText: {
                color: 'text.default',
            },
        },
    },
    ContentCards: {
        baseStyle: {
            subtitle: {
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
                opacity: 0.7,
            },
            text: {
                textStyle: 'body-large',
                fontWeight: 'normal',
            },
            closeIconInnerContainer: {
                color: 'text.default',
                background: 'background.default',
                borderRadius: '100%',
            },
            closeIcon: {
                boxSize: {base: remCalc(12), md: 'iconsSize.small', xl: remCalc(20)},
            },
        },
    },
    HeroBannerText: {
        baseStyle: {
            textTitleDescription: {
                fontWeight: 'normal',
            },
            textTitle: {
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
            },
        },
    },
    HeroBannerCountdown: {
        baseStyle: {
            timeNumber: {
                textStyle: 'head-xlarge',
                fontWeight: 'medium',
            },
            text: {textStyle: 'body-small', fontWeight: 'normal'},
        },
    },
    SideCard: {
        baseStyle: {
            textTitleLabel: {
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
            },
            textTitleDescriptionStandard: {
                fontWeight: 'normal',
            },
            textTitleDescriptionPdpVertical: {
                fontWeight: 'normal',
            },
            textTitleDescriptionPdpVerticalSimple: {
                fontWeight: 'normal',
            },
            textTitleVerticalLabel: {
                fontWeight: 'normal',
            },
            textTitleDescriptionVertical: {
                fontWeight: 'normal',
            },
        },
    },
    Checkbox: {
        baseStyle: {
            control: {
                borderRadius: remCalc(2),
            },
        },
    },
    ErrorAndMaintenancePage: {
        baseStyle: {
            errorPage: {
                pageContainer: {
                    border: 'none',
                },
                goBackButton: {
                    background: 'button.background.primary-default',
                    _hover: {
                        background: 'button.background.primary-hover',
                    },
                    _focus: {
                        background: 'button.background.primary-default',
                    },
                    _focusVisible: {
                        background: 'button.background.primary-default',
                    },
                },
            },
        },
    },
    PromoSlider: {
        baseStyle: {
            container: {
                backgroundColor: 'background.light',
            },
            chevronIcon: {
                color: 'background.default',
                backgroundColor: 'background.overlay-modal',
                borderRadius: '100%',
                border: 'none',
            },
            imageCardChevronIcon: {
                backgroundColor: 'transparent',
                borderRadius: 'none',
                color: 'text.inverse',
            },
            videoTitle: {
                fontWeight: 'normal',
            },
            heading: {
                fontWeight: 'normal',
            },
            label: {
                fontWeight: 'normal',
            },
            title: {
                fontWeight: 'normal',
            },
            textTitleDescription: {
                fontWeight: 'normal',
            },

            textTitleDescriptionImage: {
                fontWeight: 'normal',
            },
        },
    },
    Moodboard: {
        baseStyle: {
            chevronIcon: {
                color: 'background.default',
                backgroundColor: 'background.overlay-modal',
            },
            moodboardChevronIcon: {
                color: 'text.inverse',
                backgroundColor: 'transparent',
            },
        },
    },
    PlpGridCard: {
        baseStyle: {
            buttonPlpGridCard: {
                color: 'text.default',
                backgroundColor: 'background.default',
                borderRadius: '100%',
                border: 'none',
            },
        },
    },
    KeyFeatures: {
        baseStyle: {
            headerGrid: {
                color: 'text.default',
            },
            cardTitle: {
                color: 'text.default',
            },
            cardDescription: {
                color: 'text.default',
            },
        },
    },
    ContactUs: {
        baseStyle: {
            title: {
                fontWeight: 'normal',
            },
            rightSection: {
                p: {
                    color: 'text.default',
                },
                ul: {
                    color: 'text.default',
                    textStyle: 'body-small',
                },
                li: {
                    color: 'text.default',
                },
                a: {
                    color: 'text.default',
                    textDecoration: 'underline',
                },
                b: {
                    color: 'text.default',
                    fontWeight: 'normal',
                },
                em: {
                    textStyle: 'body-xsmall',
                    color: 'text.default',
                },
            },
            confirmationButtonText: {
                fontWeight: 'medium',
            },
        },
    },
    Search: {
        baseStyle: {
            logo: {
                width: {base: `${remCalc(83)}`, lg: `${remCalc(96)}`},
                height: {base: `${remCalc(34)}`, lg: `${remCalc(40)}`},
            },
            searchSuggestions: {borderRadius: remCalc(8)},
        },
        variants: {
            modalSearch: {
                searchHStack: {
                    padding: `${remCalc(8)} 0 0 0`,
                },
                searchSuggestions: {borderColor: 'border.default'},
            },
            faqSearch: {
                popoverContent: {
                    width: 'full',
                    border: 'unset',
                    marginTop: remCalc(-8),
                },
                searchSuggestions: {borderColor: 'border.default'},
            },
        },
    },
    Faq: {
        baseStyle: {
            searchAndTitleStyles: {
                titleText: {
                    fontWeight: 'normal',
                },
                subTitleText: {
                    fontWeight: 'normal',
                },
                errorMessage: {
                    color: 'text.default',
                },
            },
            categoriesCardStyles: {
                categoriesTitle: {
                    fontWeight: 'normal',
                },
            },
            singleArticleStyles: {
                paragraphs: {
                    fontWeight: 'normal',
                },
                strongText: {
                    fontWeight: 'semibold',
                    color: 'text.secondary',
                },
            },
            bannerFaqStyles: {
                bannerHeading: {
                    fontWeight: 'normal',
                },
            },
            articlesListStyles: {
                toogleText: {
                    fontWeight: 'semibold',
                },
            },
            goBackButtonStyles: {
                outerContainer: {
                    color: 'text.default',
                },
            },
        },
    },
    GridCard: {
        baseStyle: {
            cardText: {
                fontWeight: 'normal',
            },
        },
    },
    Manuals: {
        baseStyle: {
            headerTitle: {
                fontWeight: 'normal',
                color: 'text.default',
                textStyle: 'head-xlarge',
            },
            headerSubtitle: {
                fontWeight: 'normal',
                textStyle: 'head-medium',
            },
        },
    },
    GridTemplate: {
        baseStyle: {
            header: {
                textStyle: 'head-medium',
                fontWeight: 'normal',
            },
        },
    },
    InformativeLabel: {
        baseStyle: {
            as: 'span',
            padding: `${remCalc(2)} ${remCalc(4)}`,
            textStyle: 'body-xsmall',
            textTransform: null,
            fontWeight: 'light',
            color: 'label.text.primary',
            backgroundColor: 'label.background.primary',
        },
        variants: {
            primary: {
                color: 'label.text.primary',
                backgroundColor: 'label.background.primary',
            },
            secondary: {
                color: 'label.text.secondary',
                backgroundColor: 'label.background.secondary',
            },
            success: {
                color: 'label.text.success',
                backgroundColor: 'label.background.success',
            },
            grey: {
                backgroundColor: 'border.disabled',
            },
            disable: {
                color: 'label.text.disable',
                backgroundColor: 'label.background.disable',
            },
            danger: {
                color: 'label.text.danger',
                backgroundColor: 'background.danger',
            },
            'food-preparation': {
                color: 'label.text.primary',
                backgroundColor: 'label.background.primary',
            },
            cooking: {
                color: 'label.text.tertiary',
                backgroundColor: 'label.background.tertiary',
            },
            breakfast: {
                color: 'label.text.quaternary',
                backgroundColor: 'label.background.quaternary',
            },
            ironing: {
                color: 'label.text.quinary',
                backgroundColor: 'label.background.quinary',
            },
        },
    },
    Account: {
        baseStyle: () => {
            const hidePassword = getAssetUrl('static/img/form/hide-password-br.svg')
            const showPassword = getAssetUrl('static/img/form/show-password-br.svg')

            return {
                '.gigya-screen .gigya-composite-control-password-peek input[type=password] + .gigya-show-password-button .gigya-password-icon, .gigya-screen .gigya-composite-control-password-peek[data-show-password=false] .gigya-password-icon':
                    {
                        content: `url("${hidePassword}")`,
                    },
                '.gigya-screen .gigya-composite-control-password-peek input[type=text] + .gigya-show-password-button .gigya-password-icon, .gigya-screen .gigya-composite-control-password-peek[data-show-password=true] .gigya-password-icon':
                    {
                        content: `url("${showPassword}")`,
                    },
                accountTitle: {
                    fontWeight: 'normal',
                },
                headingTitle: {
                    fontWeight: 'normal',
                },
                title: {
                    fontWeight: 'normal',
                },
                shippingSubtitle: {
                    fontWeight: 'normal',
                },
                brandContainer: {
                    borderTopLeftRadius: remCalc(7.45),
                    borderTopRightRadius: remCalc(7.45),
                },
                '.gigya-composite-control-textbox:focus-within .gigya-label, .gigya-composite-control-textbox .gigya-label:has(~ .gigya-valid, ~ .gigya-error, ~ input[type=date]), [data-screenset-element-id=gigya-complete-registration-screen] .gigya-composite-control-textbox .gigya-label:has(~ input[name="profile.email"])':
                    {
                        color: 'text.default',
                    },
            }
        },
    },
    Wishlist: {
        baseStyle: {
            wishlistTitle: {
                fontWeight: 'normal',
            },
            wishlistStack: {
                gap: {base: remCalc(24), lg: remCalc(40)},
            },
            productDetailPrice: {
                textStyle: 'body-medium',
            },
        },
    },
    MarketingPreferences: {
        baseStyle: {
            accountTitle: {
                fontWeight: 'normal',
            },
            '.gigya-composite-control-textbox:focus-within .gigya-label': {
                color: 'text.default',
            },
            '.gigya-layout-row:nth-child(4) .gigya-custom-checkbox:before': {
                borderColor: 'border.default',
            },
            '.gigya-layout-row:nth-child(4) .gigya-custom-checkbox:has(.gigya-input-checkbox:checked):after':
                {
                    borderColor: 'border.default',
                },
            '.gigya-composite-control-checkbox .gigya-checkbox-text': {
                color: 'text.default',
            },
        },
    },
    OrderHistory: {
        baseStyle: {
            title: {
                fontWeight: 'normal',
                textStyle: {base: 'head-large', lg: 'head-xlarge'},
            },
            noOrdersTitle: {
                fontWeight: 'normal',
            },
        },
    },
    Orders: {
        baseStyle: {
            header: {
                textStyle: {base: 'head-small', lg: 'head-medium'},
                fontWeight: 'normal',
            },
            detailsLink: {
                color: 'text.primary',
            },
            goBackToOrderHistory: {
                color: 'text.primary',
            },
            orderNumberHeader: {
                textStyle: {base: 'head-medium', lg: 'head-xlarge'},
                fontWeight: 'normal',
            },
            stackWrapper: {
                borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
                p: {base: remCalc(16), md: remCalc(24)},
            },
            borderWrapper: {
                borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
            },
            orderReturnHeaderNumDateContainer: {
                borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
            },
            orderReturnHeaderTitle: {
                textStyle: {base: 'head-large', lg: 'head-xlarge'},
                fontWeight: 'normal',
            },
            returnFormWarningContainer: {
                borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
            },
            expiredReturnContainer: {
                borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
            },
            expiredNoReturnContainer: {
                borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
            },
            returnOrderSelect: {
                borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
            },
            returnModalContainer: {
                borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
                paddingTop: [remCalc(24), remCalc(24), remCalc(24), remCalc(24)],
                paddingBottom: [remCalc(24), remCalc(24), remCalc(24), remCalc(24)],
            },
            returnModalButton: {
                color: 'text.primary',
                fontWeight: 'medium',
            },
            tertiaryButton: {
                color: 'text.default',
                whiteSpace: 'normal',
                fontWeight: 'medium',
            },
            tertiaryButtonLine: {
                color: 'text.default',
                fontWeight: 'medium',
            },
            orderDetailsNonReturnableItemsContainer: {
                px: {base: 0, lg: remCalc(24)},
            },
            formCancellationContainer: {
                flexDirection: {base: 'column', md: 'column'},
            },
            confirmCancellationText: {
                textStyle: 'head-large',
                fontWeight: 'normal',
            },
            cancellationHeader: {
                textStyle: 'head-small',
                fontWeight: 'normal',
            },
            confirmationDate: {
                fontWeight: 'normal',
            },
            orderDetailsReturnContainer: {
                borderRadius: 'xsmall.base',
            },
        },
    },
    Header: {
        baseStyle: {
            headerBar: {
                backgroundColor: 'background.dark',
                border: 'unset',
                borderTop: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
            },
            headerButton: {
                backgroundColor: 'background.default',
            },
            wishlistIcon: {
                '@media (max-width: 1199px)': {
                    fill: 'background.default',
                    color: 'text.inverse',
                    width: remCalc(20),
                    height: remCalc(20),
                },
                '@media (min-width: 1200px)': {
                    fill: 'background.default',
                    color: 'text.inverse',
                    width: remCalc(20),
                    height: remCalc(20),
                },
            },
            wishlistBadge: {
                backgroundColor: 'text.tertiary',
                color: 'text.default',
                borderColor: 'text.tertiary',
                textStyle: 'body-xxsmall',
                fontWeight: 'normal',
                top: remCalc(18),
            },
            accountIcon: {
                '@media (max-width: 1199px)': {
                    color: 'text.inverse',
                    width: remCalc(20),
                    height: remCalc(20),
                },
                '@media (min-width: 1200px)': {
                    color: 'text.inverse',
                    width: remCalc(20),
                    height: remCalc(20),
                },
            },
            initialsText: {
                color: 'text.default',
                '@media (max-width: 1199px)': {
                    textStyle: 'body-xxsmall',
                    fontWeight: '400',
                },
            },
            buttonIcons: {
                color: 'text.inverse',
            },
            containerSpacing: {
                '@media (min-width: 1400px)': {
                    paddingY: 'small.base',
                    mx: 'auto',
                },
                '@media (min-width: 1023px)': {
                    paddingY: 'small.base',
                    mx: 'auto',
                },
            },
            logo: {
                '@media (max-width: 1023px)': {
                    width: remCalc(73),
                    height: remCalc(30),
                },
                '@media (min-width: 1024px)': {
                    width: remCalc(75),
                    height: remCalc(31),
                },
                marginBottom: 'xsmall.base',
            },
            headerIcon: {
                '@media (max-width: 1199px)': {
                    width: remCalc(20),
                    height: remCalc(20),
                },
                '@media (min-width: 1200px)': {
                    width: remCalc(20),
                    height: remCalc(20),
                },
            },
            burgerIcon: {
                width: remCalc(20),
                height: remCalc(20),
            },
            content: {
                height: remCalc(40),
            },
            iconsFlexGap: {
                gap: {base: remCalc(16), md: remCalc(16), lg: remCalc(16)},
                '@media (min-width: 1199px)': {
                    gap: remCalc(16),
                },
            },
            bodyContainerGap: {
                '@media (max-width: 1199px)': {
                    gap: 0,
                },
                '@media (min-width: 1200px)': {
                    gap: remCalc(64),
                },
            },
        },
        variants: {
            checkout: {
                headerBar: {
                    backgroundColor: 'background.dark',
                    color: 'text.inverse',
                },
            },
        },
    },
    Field: {
        baseStyle: {
            label: {
                lineHeight: remCalc(14),
            },
            input: {
                borderRadius: remCalc(8),
                borderColor: 'border.default',
                _hover: {
                    borderColor: 'border.default',
                },
                _focus: {
                    borderColor: 'border.default',
                },
                _focusVisible: {
                    borderColor: 'border.default',
                },
            },
            textArea: {
                borderColor: 'border.default',
            },
        },
    },
    Dropdown: {
        baseStyle: {
            '.react-select__control': {
                borderColor: 'border.default',
            },
        },
        variants: {
            orderCancellation: {
                '.react-select__indicator': {
                    paddingX: remCalc(16),
                },
                '.react-select__value-container--has-value': {
                    px: remCalc(16),
                },
                '.react-select__value-container': {
                    px: remCalc(16),
                },
            },
        },
    },
    MiniCartPopover: {
        baseStyle: {
            cartIcon: {
                '@media (max-width: 1199px)': {
                    width: remCalc(20),
                    height: remCalc(20),
                    color: 'text.inverse',
                },
                '@media (min-width: 1200px)': {
                    width: remCalc(20),
                    height: remCalc(20),
                    color: 'text.inverse',
                },
            },
            badge: {
                backgroundColor: 'text.tertiary',
                color: 'text.default',
                borderColor: 'text.tertiary',
                textStyle: 'body-xxsmall',
                fontWeight: 'normal',
                top: remCalc(18),
            },
            productHeading: {
                textStyle: 'head-xsmall',
            },
        },
    },
    SovraHeader: {
        baseStyle: {
            container: {
                backgroundColor: 'background.light',
            },
            containerDesktop: {
                display: {base: 'none', md: 'flex'},
            },
            containerMobile: {
                display: {base: 'flex', md: 'none'},
            },
            iconArrow: {
                color: 'text.default',
            },
            icon: {
                color: 'text.default',
                width: remCalc(6),
                height: remCalc(1),
                opacity: 0.5,
            },
            labelColor: {
                color: 'text.default',
            },
            labelSmall: {
                fontWeight: '400',
            },
            hstack: {
                gap: {md: remCalc(32), lg: remCalc(96)},
            },
        },
    },
    ProductHeader: {
        baseStyle: {
            title: {
                fontWeight: 400,
            },
        },
    },
    PriceCard: {
        baseStyle: {
            currentPrice: {
                fontWeight: 'normal',
            },
            listPrice: {
                fontWeight: 'normal',
            },
            discount: {
                fontWeight: 'normal',
            },
        },
        variants: {
            pdpSelectorCurrentVariant: {
                currentPrice: {
                    fontSize: remCalc(28),
                    lineHeight: remCalc(35),
                    fontWeight: 'normal',
                },
                discount: {
                    textStyle: 'body-medium',
                },
                listPrice: {
                    textStyle: 'body-medium',
                },
            },
        },
    },
    WhatsInTheBox: {
        baseStyle: {
            headerLabel: {
                fontWeight: 'normal',
            },
            itemLabel: {
                fontWeight: 'medium',
            },
        },
    },
    OrderSummary: {
        baseStyle: {
            checkoutSection: {
                totalText: {
                    fontWeight: 'medium',
                },
            },
            mobileOrderReviewContainer: {
                paddingX: remCalc(32),
            },
        },
        variants: {
            checkout: {
                orderSummaryBox: {
                    paddingX: {base: remCalc(32), lg: remCalc(24)},
                },
            },
        },
    },
    Checkout: {
        baseStyle: {
            toggleIconBox: {
                backgroundColor: 'text.tertiary',
            },
            /*             toggleIconFlexBraun: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            editButton: {
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'normal',
            }, */
        },
    },
    QuantityPicker: {
        baseStyle: {
            decButton: {
                bg: 'background.light',
                color: 'background.secondary',
            },
            quantityIcon: {
                padding: remCalc(5),
            },
            decButtonActive: {
                padding: remCalc(5),
                color: 'icons.background.primary',
            },
            incButton: {
                padding: remCalc(5),
            },
            incButtonActive: {
                padding: remCalc(5),
                color: 'icons.background.primary',
            },
        },
    },
    Login: {
        baseStyle: () => {
            const hidePassword = getAssetUrl('static/img/form/hide-password-br.svg')
            const showPassword = getAssetUrl('static/img/form/show-password-br.svg')

            return {
                '.gigya-screen .gigya-composite-control-password-peek input[type=password] + .gigya-show-password-button .gigya-password-icon, .gigya-screen .gigya-composite-control-password-peek[data-show-password=false] .gigya-password-icon':
                    {
                        content: `url("${hidePassword}")`,
                    },
                '.gigya-screen .gigya-composite-control-password-peek input[type=text] + .gigya-show-password-button .gigya-password-icon, .gigya-screen .gigya-composite-control-password-peek[data-show-password=true] .gigya-password-icon':
                    {
                        content: `url("${showPassword}")`,
                    },
                myAccountTitle: {
                    fontWeight: 'normal',
                },
                '.gigya-forgotPassword': {
                    color: 'text.primary',
                },
                '.dlg-gigya-link': {
                    color: 'text.primary',
                },
                '[data-screenset-element-id=gigya-subscribe-with-email-screen] .dln-newUserForm__paragraph--main':
                    {
                        color: 'text.default',
                        textStyle: 'body-medium',
                    },
                '.gigya-composite-control-textbox:focus-within .gigya-label, .gigya-composite-control-textbox .gigya-label:has(~ .gigya-valid, ~ .gigya-error, ~ input[type=date]), [data-screenset-element-id=gigya-complete-registration-screen] .gigya-composite-control-textbox .gigya-label:has(~ input[name="profile.email"])':
                    {
                        color: 'text.default',
                    },
                '.gigya-input-checkbox+label.gigya-label:before, .gigya-input-checkbox+label.subscription-name-label:before':
                    {
                        borderColor: 'border.default',
                    },
                '.gigya-input-checkbox+label.gigya-label:after, .gigya-input-checkbox+label.subscription-name-label:after':
                    {
                        borderColor: 'border.default',
                    },
                '.dln-completeForm__paragraph--secondary': {
                    color: 'text.default',
                },
                '.gigya-composite-control-checkbox .gigya-checkbox-text, .subscription-name-label':
                    {
                        color: 'text.default',
                    },
                '#gigya-forgotten-password-container .dlg-gigya-input-text-wrapper input': {
                    px: {base: 'xsmall.base', lg: 'xsmall.lg'},
                    py: {base: 'xxsmall.base', lg: 'xxsmall.lg'},
                },
            }
        },
    },
    ServiceCenterLocator: {
        baseStyle: {
            title: {
                fontWeight: 'normal',
            },
            locator: {
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.dark',
            },
            serviceCenterAddressMainContainer: {
                gap: {
                    base: 'small.base',
                    sm: 'small.base',
                    md: 'xsmall.base',
                    lg: 'xsmall.base',
                },
            },
            removeAllButton: {
                textDecoration: 'none',
            },
            selectedFilterValue: {
                fontWeight: 'normal',
            },
            filterSectionContainerMobile: {
                w: {base: `calc(100% - ${remCalc(32)})`, lg: remCalc(312)},
            },
            filterPopUpContainer: {
                justifyContent: 'center',
                alignItems: 'center',
                display: {base: 'flex', lg: 'none'},
                paddingTop: remCalc(24),
                paddingBottom: remCalc(24),
                w: '100%',
                gap: remCalc(0),
            },
            filterIconContainer: {
                maxH: remCalc(72),
            },
            filterPopUpCloseIcon: {
                position: 'absolute',
                right: remCalc(12),
                top: remCalc(24),
                w: 'iconsSize.large',
                h: 'iconsSize.large',
                display: {
                    base: 'block',
                    lg: 'none',
                },
                padding: remCalc(4),
            },
            filterPopUpTitle: {
                fontWeight: 'light',
                fontSize: {base: remCalc(18)},
            },
            distanceTitleContainer: {
                fontWeight: 'light',
                fontSize: {base: remCalc(18)},
            },
            checkboxTitle: {
                fontWeight: 'light',
                fontSize: {base: remCalc(18)},
            },
            selectedFilterItem: {
                fontWeight: 'light',
                fontSize: {base: remCalc(14)},
            },
            checkboxFilterItem: {
                textStyle: 'body-small',
                fontWeight: 'light',
                fontSize: {base: remCalc(14)},
            },
        },
    },
    Modal: {
        baseStyle: {
            modalContent: {
                padding: {base: remCalc(16), sm: remCalc(16), md: remCalc(16), lg: remCalc(24)},
            },
            modalHeaderTitle: {
                textStyle: 'body-small',
                fontWeight: 'normal',
            },
            productGrid: {
                gap: {base: remCalc(16)},
            },
            addedToCartIcon: {
                boxSize: {base: 'iconsSize.small'},
                color: 'text.tertiary',
            },
            addedToCartText: {
                color: 'text.tertiary',
            },
            checkIconBox: {
                color: 'text.default',
                boxSize: {base: 'iconsSize.medium', lg: 'iconsSize.large'},
            },
            boldText: {
                fontWeight: 'semibold',
            },
        },
    },
    Cart: {
        baseStyle: {
            shipping: {
                shippingContent: {
                    gap: {base: remCalc(8), lg: remCalc(16)},
                },
                shippingText: {
                    fontWeight: 'semibold',
                },
                shippingContainer: {
                    borderColor: 'border.dark',
                },
            },
            header: {
                title: {
                    fontWeight: 'normal',
                },
            },
        },
    },
    Confirmation: {
        baseStyle: {
            checkIconBox: {
                backgroundColor: 'text.tertiary',
                borderColor: 'text.tertiary',
                boxSize: 'iconsSize.medium',
            },
            checkIcon: {
                boxSize: 'iconsSize.medium',
            },
            confirmationLink: {
                color: 'text.tertiary',
            },
            orderSummaryItem: {
                borderRadius: `${remCalc(8)} ${remCalc(8)} 0 0`,
            },
            orderSummaryTitle: {
                fontWeight: 'semibold',
            },
            orderSummaryDetails: {
                gap: 0,
            },
            productItem: {
                gap: remCalc(16),
            },
            products: {
                p: {base: remCalc(32), lg: remCalc(24)},
            },
        },
    },
    Sorting: {
        baseStyle: {
            heading: {
                fontWeight: 'normal',
            },
            chevronIcon: {
                borderColor: 'border.inverse',
            },
        },
        variants: {
            black: {
                main: {
                    backgroundColor: 'background.dark',
                    color: 'text.inverse',
                },
                chevronIcon: {
                    borderColor: 'border.default',
                },
            },
        },
    },
    PageHeader: {
        baseStyle: {
            braunCounter: {
                color: 'text.secondary',
            },
        },
    },
    ProductComparePlp: {
        baseStyle: {
            tileProductName: {
                whiteSpace: 'nowrap',
            },
        },
    },
    productItem: {
        itemName: {
            paddingRight: remCalc(8),
        },
    },
    RecommendedProducts: {
        baseStyle: {
            outerContainer: {
                layerStyle: 'page',
                pt: {base: remCalc(24), lg: remCalc(16)},
                pb: {base: remCalc(24), lg: remCalc(96)},
                gap: {base: '0', lg: remCalc(16)},
            },
            headerLabel: {
                fontWeight: 'normal',
                px: {
                    base: remCalc(16),
                    md: remCalc(64),
                    xl: 0,
                },
                py: {
                    base: remCalc(16),
                    lg: remCalc(32),
                },
            },
            scrollableContainer: {
                justifyContent: 'flex-start',
                gap: {base: 'xsmall.base', md: 'small.md', lg: 'small.lg', xl: 'small.lg'},
                px: {base: remCalc(16), md: remCalc(64), xl: 0},
            },
            productDetailsContainer: {
                gap: {base: remCalc(8), lg: remCalc(16)},
            },
        },
    },
    RecipeHeroBanner: {
        baseStyle: {
            infoIcons: {
                color: 'text.default',
            },
            infoTileTitle: {
                color: 'text.default',
                fontWeight: 'medium',
            },
            infoTitle: {
                fontWeight: 'medium',
            },
        },
    },
    RecipeTile: {
        baseStyle: {
            titleText: {
                fontWeight: 'medium',
            },
            infoText: {
                textStyle: 'body-xsmall',
                fontWeight: 'light',
            },
        },
    },
    RecipeDetails: {
        baseStyle: {
            productSuggestion: {
                textBoxTitleText: {
                    fontWeight: 'medium',
                },
            },
            ingredientsMenu: {
                ingredientsTitle: {
                    fontWeight: 'medium',
                },
                ingredientMenuTitle: {
                    fontWeight: 'medium',
                },
                recipeUtensilsStyles: {
                    title: {
                        fontWeight: 'medium',
                    },
                    text: {
                        textStyle: 'body-large',
                    },
                },
            },
            stepsMenu: {
                stepsTitle: {
                    fontWeight: 'medium',
                },
            },
        },
    },
    ProductMoodboard: {
        baseStyle: {
            content: {
                '.swiper-pagination-bullet-active': {
                    textDecorationThickness: remCalc(2),
                    textTransform: 'none',
                },
            },
            tabs: {
                display: 'none',
            },
            pagination: {
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
                mb: {base: remCalc(16), lg: remCalc(24)},
                display: 'flex',
            },
            imageoverlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.026)',
            },
            productId: {
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
                textTransform: 'none',
            },
            productName: {
                textStyle: 'head-xsmall',
                fontWeight: 'medium',
            },
            omnibusPrice: {
                textStyle: 'body-xsmall',
                color: 'text.secondary',
            },
        },
    },
    PlpBannerPromo: {
        baseStyle: {
            main: {
                alignItems: {md: 'center'},
            },
            heading: {
                fontWeight: 'normal',
            },
            imagebox: {
                flexBasis: {base: '100%', md: remCalc(229), lg: remCalc(226), xl: remCalc(262.154)},
                overflow: 'hidden',
                borderRadius: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            },
        },
    },
    Bundle: {
        baseStyle: {
            headerLabel: {
                fontWeight: 'normal',
            },
            plusIcon: {
                boxSize: {base: remCalc(20), lg: remCalc(34)},
            },
            plusIconContainerMobile: {
                height: {base: remCalc(20), lg: '100%'},
            },
        },
    },
    Paperless: {
        baseStyle: {
            productDetailsTitle: {
                fontWeight: 'normal',
            },
            headingTitle: {
                fontWeight: 'medium',
            },
            headingPageTitle: {
                fontWeight: 'normal',
            },
            dropdownContainer: {
                paddingY: {
                    base: remCalc(4),
                    sm: remCalc(4),
                    md: 'unset',
                    lg: 'unset',
                },
            },
            productManualsHeader: {
                gap: {
                    base: 'xsmall.base',
                    lg: 'unset',
                },
                marginBottom: {
                    base: remCalc(16),
                    sm: remCalc(16),
                    md: remCalc(34),
                    lg: remCalc(34),
                },
            },
            productManualCard: {
                paddingY: {base: remCalc(20), md: remCalc(24)},
            },
            divider: {
                my: 'unset',
            },
            productManualsContainer: {
                gap: 'unset',
            },
            pageContainer: {
                gap: {base: remCalc(24), md: remCalc(80)},
            },
            productSection: {
                gap: {base: remCalc(40), lg: 'medium.base'},
            },
        },
    },
    Iconbox: {
        baseStyle: {
            sectionTitle: {
                fontWeight: 'light  ',
            },
        },
    },
    GigyaModal: {
        baseStyle: {
            content: {
                borderRadius: 'large.base',
            },
        },
    },
}
export default {
    components: overrides,
}
